import { Card, List, Button, Modal } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllAnnouncement, addAnnouncement } from "../../redux/rtk/features/announcement/announcementSlice";
import dayjs from "dayjs";

const TitleComponent = ({ item, onEdit, onDelete }) => {
	return (
		<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
			<h2 style={{ margin: 0, flex: 1, marginRight: '10px', fontSize: '16px' }}>
				{item.AnnouncementText && item.AnnouncementText.substring(0, 20)}...
			</h2>
			<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<button 
					onClick={() => onEdit(item)} 
					style={{ 
						backgroundColor: '#52c41a',
						border: '1px solid #52c41a',
						color: 'white',
						borderRadius: '4px',
						padding: '4px 8px',
						minWidth: '32px',
						height: '32px',
						cursor: 'pointer',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
					title="Edit Announcement"
				>
					<EditOutlined style={{ color: 'white', fontSize: '14px' }} />
				</button>
				<button 
					onClick={() => onDelete(item)} 
					style={{ 
						backgroundColor: '#ff4d4f',
						border: '1px solid #ff4d4f',
						color: 'white',
						borderRadius: '4px',
						padding: '4px 8px',
						minWidth: '32px',
						height: '32px',
						cursor: 'pointer',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
					title="Delete Announcement"
				>
					<DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
				</button>
			</div>
		</div>
	);
};

const GetAllAnnouncement = ({ setEditData }) => {
	const { loading, list } = useSelector((state) => state.announcement);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllAnnouncement());
	}, []);

	const handleEdit = (announcement) => {
		setEditData(announcement);
	};

	const handleDelete = (announcement) => {
		Modal.confirm({
			title: 'Delete Announcement',
			content: 'Are you sure you want to delete this announcement? This action cannot be undone.',
			okText: 'Yes, Delete',
			okType: 'danger',
			cancelText: 'Cancel',
			onOk: async () => {
				try {
					// Use addAnnouncement API with all announcement data and DataStatus=2 for delete
					const deleteData = {
						AnnouncementId: announcement.AnnouncementId,
						AnnouncementText: announcement.AnnouncementText,
						AnnouncementStartDate: announcement.AnnouncementStartDate,
						AnnouncementEndDate: announcement.AnnouncementEndDate,
						DataStatus: 2
					};
					
					const resp = await dispatch(addAnnouncement(deleteData));
					if (resp.payload.message === "success") {
						dispatch(loadAllAnnouncement());
					}
				} catch (error) {
					// console.log(error.message);
				}
			}
		});
	};

	const formatDate = (dateString) => {
		if (!dateString) return "Not specified";
		return dayjs(dateString).format("YYYY-MM-DD");
	};

	return (
		<Card className="announcement-list-card">
			<h2 className='text-center text-2xl txt-color-2 announcement-list-header'>Announcements</h2>
			<hr className='mt-3 mb-5 mx-5' />
			<div className="announcement-list-wrapper">
				<List
					className='m-4'
					loading={loading}
					grid={{
						gutter: 16,
						xs: 1,
						sm: 2,
						md: 2,
						lg: 3,
						xl: 3,
						xxl: 3,
					}}
					dataSource={list ? list : []}
					renderItem={(item) => (
						<List.Item className='new-card'>
							<Card>
								<div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '12px', marginBottom: '12px' }}>
									<TitleComponent item={item} onEdit={handleEdit} onDelete={handleDelete} />
								</div>
								<p>{item.AnnouncementText}</p>
								<div className="mt-3 text-sm text-gray-500">
									<p>Start Date: {formatDate(item.AnnouncementStartDate)}</p>
									<p>End Date: {formatDate(item.AnnouncementEndDate)}</p>
								</div>
							</Card>
						</List.Item>
					)}
				/>
			</div>
		</Card>
	);
};

export default GetAllAnnouncement;